export const getYearString = (value: string): string => {
	let year;

	if (value === null || value === '') {
		year = '';
	} else if (value.length > 4) {
		year = String(value.slice(0, 4));
	} else {
		year = value;
	}

	return year;
};
